import PermissionManager from './PermissionManager';

export default PermissionManager;
